import { Box, Typography } from "@mui/material";
import { ExtraCategory, TextureCategory } from "@shared/core";
import React, { JSX } from "react";
import { useMounted, UseMountedProps } from "../../hooks/common";
import { useDeviceStyles } from "../../hooks/useDeviceStyles";
import { colors, transitions } from "../../styles/theme";
import { Container } from "./ActiveHolder.styled";

export type ActiveHolderProps = {
  active: boolean;
  name: string | string[];
  type: TextureCategory["type"] | ExtraCategory["type"];
  description?: string[];
  price?: string;
} & UseMountedProps &
  React.ComponentProps<typeof Container>;

export const ActiveHolder: React.FC<ActiveHolderProps> = (
  props,
): JSX.Element => {
  const { active, name, type, anchor, description, price, children, ...rest } =
    props;
  const { mounted } = useMounted({ anchor });
  const { isMobileDevice } = useDeviceStyles();

  const circleGutter = type === "texture" ? 20 : 14;
  const circleBorderWidth = type === "texture" ? 2 : 2;
  const circleAfterBorderWidth =
    type === "texture"
      ? circleGutter - circleBorderWidth * 2
      : circleGutter - circleBorderWidth;
  // const lineWidth = type === "texture" ? 2 : 2;
  const lineWidth = isMobileDevice ? 1 : 2;
  const lineHeight =
    type === "texture" ? (isMobileDevice ? 10 : 24) : isMobileDevice ? 12 : 18;

  return (
    <Container
      {...rest}
      $type={type}
      $hasPrice={!!price}
      sx={
        {
          // ...rpx({
          //   paddingLeft: '36px',
          //   paddingRight: '36px',
          //   paddingTop: '54px',
          //   ...(type === 'texture' && {
          //     paddingBottom: '116px',
          //   }),
          // }, {
          //   mobile: {
          //     paddingLeft: '6px',
          //     paddingRight: '6px',
          //     paddingTop: '10px',
          //     paddingBottom: '10px',
          //   }
          // })
        }
      }
    >
      <>
        {/* @ts-ignore */}
        <Box
          sx={(theme) => ({
            position: "relative",
            userSelect: "none",
            // width: "126px",
            // height: "126px",
            ...(type === "texture" && {
              width: isMobileDevice ? 52 : 80,
              height: isMobileDevice ? 52 : 80,

              /*...rpx(
                { width: 126, height: 126 },
                { mobile: { width: 52, height: 52 } },
              ),*/
              // ...convertToBreakpoints(theme, {
              //   xs: { width: 52, height: 52 },
              //   md: { width: 66, height: 66 },
              //   xxl: { width: 90, height: 90 },
              //   xxxl: { width: 126, height: 126 },
              // })
            }),
            ...(type === "extra" && {
              width: isMobileDevice ? 10 : 36,
              height: isMobileDevice ? 10 : 36,

              /*...rpx(
                { width: 54, height: 54 },
                { mobile: { width: 10, height: 10 } },
              ),*/

              // ...convertToBreakpoints(theme, {
              //   xs: { width: 28, height: 28 },
              //   md: { width: 32, height: 32 },
              //   lg: { width: 40, height: 40 },
              //   xxxl: { width: 54, height: 54 },
              // })
            }),
            "&::before, &::after": {
              content: mounted && "''",
              borderRadius: "50%",
              position: "absolute",
              bottom: 0,
              right: 0,
              zIndex: 2,
            },
            "&::before": {
              width: `calc(100% + ${circleGutter}px)`,
              height: `calc(100% + ${circleGutter}px)`,
              top: `-${circleGutter / 2}px`,
              left: `-${circleGutter / 2}px`,
              // ...(type === 'texture' && {
              //   width: `calc(100% + ${circleGutter}px)`,
              //   height: `calc(100% + ${circleGutter}px)`,
              //   top: `-${circleGutter/2}px`,
              //   left: `-${circleGutter/2}px`,
              // }),
              border: `${circleBorderWidth}px solid transparent`,
              // transition: 'border-color .5s ease 1.5s',
              transition: mounted && transitions.join(["border-color"]),
              transitionDelay: "0.3s",
              ...(type === "texture" && {
                ...(active && {
                  borderColor: colors.text.v4,
                }),
              }),
              ...(type === "extra" && {
                borderColor: "#fff",
                transitionDelay: "0.4s",
              }),
              // ...({
              //   borderColor: active ? '#fff' : undefined,
              // })
            },
            "&::after": {
              // transition: mounted && transitions.join(['border-color']),
              ...(active && {
                borderColor: colors.background.v1,
              }),
              ...(type === "texture" && {
                border: `${circleGutter / 2}px solid transparent`,
                ...(active && {
                  borderColor: `${colors.background.v1} !important`,
                  width: `calc(100% + ${circleAfterBorderWidth}px)`,
                  height: `calc(100% + ${circleAfterBorderWidth}px)`,
                  top: `-${circleAfterBorderWidth / 2}px`,
                  left: `-${circleAfterBorderWidth / 2}px`,
                }),
              }),
              ...(type === "extra" && {
                // border: `12px solid #fff`,

                border: `${circleBorderWidth}px solid ${colors.background.v1}`,
                width: `calc(100% + ${circleAfterBorderWidth}px)`,
                height: `calc(100% + ${circleAfterBorderWidth}px)`,
                top: `-${circleAfterBorderWidth / 2}px`,
                left: `-${circleAfterBorderWidth / 2}px`,

                // width: '100%',
                // height: '100%',
                // top: 0,
                // left: 0,

                // border: `2px solid red`,
                // transform: 'scale(0)',
                transition:
                  mounted &&
                  transitions.join(["background-color"], transitions.linear),
                backgroundColor: colors.background.v1,
                ...(active && {
                  backgroundColor: colors.text.v4,
                }),
              }),
              // ...({
              //   borderColor: active ? colors.background.v1 : undefined,
              // })
            },
            ...(isMobileDevice &&
              type === "texture" && {
                "&::before, &::after": {
                  display: "none",
                },
              }),
          })}
        >
          {children}
          <Box
            component={"span"}
            sx={{
              display: mounted && type !== "extra" ? "block" : "none",
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              width: `${lineWidth}px`,
              height: `${lineHeight}px`,
              backgroundColor: colors.text.v4,
              opacity: active ? 1 : 0,
              transition:
                mounted &&
                transitions.join(
                  ["backgroundColor", "opacity"],
                  transitions.linear,
                ),
              transitionDelay: ".3s",
              zIndex: 0,
            }}
          />
        </Box>
        {
          <Typography
            variant={"v4"}
            sx={{
              // eslint-disable-next-line no-mixed-operators
              fontSize: isMobileDevice ? "10px" : "40px",
              display:
                mounted &&
                (!isMobileDevice || (isMobileDevice && type === "extra"))
                  ? "block"
                  : "none",
              textAlign: "center",
              color: colors.text.v2,
              // opacity: 0,
              transition:
                mounted &&
                transitions.join(
                  ["opacity", "bottom", "transform", "color"],
                  transitions.linear,
                ),
              transitionDelay: ".4s",
              userSelect: "none",
              // minHeight: 0,
              ...(active && {
                opacity: 1,
                color: colors.text.v4,
              }),
              ...(type === "texture" && {
                position: "absolute",
                left: "50%",
                bottom: 0,
                transform: active
                  ? "translate(-50%, 0)"
                  : "translate(-50%, 10px)",
                opacity: active ? 1 : 0,
                lineHeight: 1,
              }),
              ...(type === "extra" && {
                lineHeight: 1.2,
                marginTop: isMobileDevice ? "10px" : "30px",

                // order: 2,
              }),
              maxWidth: type === "texture" ? "none" : "100%",
              whiteSpace: "normal",
              wordBreak: "keep-all",
            }}
          >
            {(Array.isArray(name) ? name : [name]).map((el) => {
              return (
                <Typography
                  key={el}
                  component={"span"}
                  sx={{
                    fontFamily: "Guton",
                    fontSize: isMobileDevice ? "10px" : "18px",
                    letterSpacing: "0.05em",
                    lineHeight: 1,
                    display: "block",
                    color: active ? colors.text.v4 : colors.text.v3,
                    ...(type === "texture" && {
                      whiteSpace: "nowrap", // keep it on one line
                    }),
                    overflow: "visible", // allow spilling out
                    textOverflow: "clip",
                  }}
                >
                  {el}
                </Typography>
              );
            })}

            <Typography
              component={"span"}
              sx={{
                fontFamily: "Guton",
                fontSize: isMobileDevice ? "8px" : "14px",
                letterSpacing: "0.05em",
                display: "block",
                ...(type === "texture" && {
                  display: price ? "block" : "none",
                }),
                ...(type === "extra" && {
                  visibility: price ? "visible" : "hidden",
                }),
                marginTop: "5px",
                order: 2,
              }}
            >
              {price ?? 0}
            </Typography>
          </Typography>
        }

        {!isMobileDevice && !!description?.length && (
          <Box sx={{ marginTop: isMobileDevice ? "0px" : "0px" }}>
            {description.map((el, index) => (
              <Typography
                key={el}
                variant={"v5_special"}
                sx={{
                  display: "block",
                  letterSpacing: "0.05em",
                  fontSize: isMobileDevice ? "8px" : "14px",
                }}
              >
                {el}
              </Typography>
            ))}
          </Box>
        )}
      </>
    </Container>
  );
};
